// === Sentry (error tracking + tracing + logs) ===
// Order matters: Sentry.init() MUST run before new Vue().$mount('#app')
// (verified at runtime by SDK; warns if mounted already)
import * as Sentry from "@sentry/vue";

Sentry.init({
  // Vue 2: pass the Vue constructor (not an app instance — that's Vue 3)
  Vue,

  // DSN is a public key — safe to ship in JS bundle, but use env var for
  // environment-specific overrides (staging vs prod).
  dsn: process.env.VUE_APP_SENTRY_DSN_KDIY_ADMIN_FRONTEND || "",

  // Environment / release tagging
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "production",
  release: process.env.VUE_APP_SENTRY_RELEASE || "kdiy-admin-frontend@1.0.0+sentry-v1",

  // Tracing (5% of transactions — fleet default for low-traffic internal app)
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05),
  // Real production API domains read from src/services/GlobalVariables.js (line 15-21):
  //   - lna.pos.co.zm       → ChickenLittle (this app's backend), KazangPaymentGateway,
  //                            kazangApi, SynergyApi/api/v1/usage/* (usage tracking)
  //   - overflow.pos.co.zm  → Franchise_OnlineServer (note: explicit port 8443 in URL,
  //                            but our regex matches the path /Franchise_OnlineServer/)
  // Excluded (per §8 of manual): placeholder IPs in comments (192.168.1.142, 192.168.1.124),
  //                            dev URLs.
  //
  // Gated on VUE_APP_SENTRY_TRACING_ENABLED: when unset / 'false', no sentry-trace
  // or baggage headers are sent on outgoing requests, so no CORS preflight is
  // triggered for them. This is the safe default until the backend CORS config
  // is updated to allow 'sentry-trace' and 'baggage' in Access-Control-Allow-Headers.
  // Set 'true' in production env after backend CORS update lands.
  tracePropagationTargets: process.env.VUE_APP_SENTRY_TRACING_ENABLED === 'true'
    ? [
        "localhost",
        /^https:\/\/lna\.pos\.co\.zm\//,
        /^https:\/\/overflow\.pos\.co\.zm\//,
      ]
    : [],

  // Logs (v8 supports this)
  enableLogs: true,

  // PII controls — fleet convention
  dataCollection: {
    userInfo: false,
    httpBodies: [],
  },

  // Strip sensitive fields from event extras (mirror of Spring Boot SentryConfig)
  beforeSend(event) {
    if (event.extra) {
      delete event.extra.password;
      delete event.extra.apiKey;
      delete event.extra.authorization;
    }
    return event;
  },
});
// === End Sentry ===

import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './services/GlobalVariables'
import './services/UsageTracker'
import DrawerLayout from 'vue-drawer-layout'
import router from './router'
import store from './store'
import './assets/fonts/icons.js'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import './registerServiceWorker'

Vue.use(DrawerLayout);
Vue.use(VueGoodTablePlugin);
Vue.component('v-select',vSelect)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
